import type { ProductRow } from '../../../services/billing';

// Ordering method is per-version now (see the Ordering method column); this
// cell only owns the vendor and the vendor-level "nothing to assign" case.
export function ProductVendorCell({ product }: { product: ProductRow }) {
    const label = product.vendorName;
    if (!label) return <span className="text-gray-300">-</span>;

    return (
        <span className="flex flex-col">
            <span className="text-gray-600 truncate">{label}</span>
            {!product.vendorHasOrderMethods && (
                <span className="text-[11px] truncate text-rose-600" title="Vendor has no methods">
                    Vendor has no methods
                </span>
            )}
        </span>
    );
}
